import { render, staticRenderFns } from "./EditPatientModal.vue?vue&type=template&id=0847f3e6&"
import script from "./EditPatientModal.vue?vue&type=script&lang=js&"
export * from "./EditPatientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports